import type { FC } from "react";
import { Text } from "@/components/podkit/typography/Text";
import { ExternalLink } from "@/components/podkit/typography/ExternalLink";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";

type Props = {
    icon?: React.ReactNode;
    title: string;
    text: string;
    docsUrl?: string;
    action?: React.ReactNode;
    "data-testid"?: string;
};
export const EnvironmentDetailsEmptySection: FC<PropsWithClassName<Props>> = ({
    className,
    title,
    text,
    icon,
    docsUrl,
    action,
    "data-testid": testId,
}) => {
    return (
        <div
            className={cn(
                "flex w-full flex-col gap-4 rounded-xl border border-dashed border-border-base px-6 py-6 @sm:max-h-[120px] sm:flex-row sm:items-center sm:gap-6 sm:pb-8 sm:pt-6",
                className,
            )}
            data-testid={testId}
        >
            {icon && <div className="hidden @xl:min-w-[80px] @xl:block">{icon}</div>}
            <div className="flex grow flex-col">
                <Text className="text-base font-bold text-content-primary">{title}</Text>
                <Text className="line-clamp-2 text-base text-content-tertiary">{text}</Text>
            </div>
            <div className="flex shrink-0 items-center gap-3">
                {docsUrl && (
                    <ExternalLink href={docsUrl} iconSize="sm" className="hidden @md:inline-flex">
                        Docs
                    </ExternalLink>
                )}
                {action}
            </div>
        </div>
    );
};
